<template>
  <div class="alert offline-card d-flex align-items-center mb-0">
    <i class="fa-solid fa-wifi mr-3 offline-icon"></i>
    <div>
      <h6 class="font-weight-bold mb-0">Desconectado</h6>
      <p class="mb-0">Verifique sua conexão com a Internet</p>
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: "COffline"
}
</script>

<style scoped>
.offline-card {
  background: var(--bg-grandient);
  border-radius: 24px;
}

.offline-icon {
  width: 44px;
  height: 44px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(199, 244, 123, 0.24);
  color: var(--text-default);
}
</style>
